(function () {
    if (window.__homepageHeroHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.homepageHero = window.Branch.homepageHero || {};
    window.Branch.homepageHero.data = window.Branch.homepageHero.data || {};
  
    window.__homepageHeroHasFired = true;

    let customFeatureImageAutoplayTimeouts = {};
    window.Branch.homepageHero.swipers = {}

function returnVideoElement(data, type, quality){
    let videoElement = document.createElement('video');
    videoElement.setAttribute('muted', 'muted');
    videoElement.muted = true;

    videoElement.setAttribute('playsinline', 'true');
    videoElement.setAttribute('autoplay', 'autoplay');
    videoElement.setAttribute('loop', 'loop');
    videoElement.setAttribute('preload', 'metadata');
    videoElement.setAttribute('poster', type == 'main' ? data.highResPoster : data.mobileHighResPoster);
    videoElement.className = type == 'main' ? 'homepage-hero__image video-desktop' : 'homepage-hero__image-mobile video-mobile' ;
    videoElement.id = type == 'main' ? quality == 'lq' ? 'feature-video-desktop-lq' : 'feature-video-desktop' : quality == 'lq' ? 'feature-video-mobile-lq' : 'feature-video-mobile';
    
    Object.assign(videoElement.style, {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: '0',
        left: '0',
        objectFit: 'cover',
        pointerEvents: 'none',
        zIndex: '2'
    });
    
    const source = document.createElement('source');
    source.src = type == 'main' ? quality == 'lq' ? data.video_src_lq : data.video_src : quality == 'lq' ? data.mobile_video_src_lq : data.mobile_video_src;
    source.type = type == 'main' ? quality == 'lq' ? data.video_type_lq : data.video_type : quality == 'lq' ? data.mobile_video_type_lq : data.mobile_video_type;
    videoElement.appendChild(source);
    
    const fallbackImg = document.createElement('img');
    fallbackImg.src = data.highResPoster;
    videoElement.appendChild(fallbackImg);
    return videoElement;
}

const loadHQVideo = function(customFeatureImage, index) {
    // Read THIS slide's settings, not the section's first settings block — otherwise every video
    // slide would be upgraded to slide 0's video. (Clones share the data-index but carry an
    // identical settings JSON, so matching the first one is fine.)
    let slideSettingsEl = customFeatureImage.querySelector(`.homepage-hero__slide[data-index="${index}"] .custom-feature-img-video-settings`);
    let data = {};
    if (slideSettingsEl) { try { data = JSON.parse(slideSettingsEl.innerText); } catch (e) { data = {}; } }

    for (let i = 0; i < 2; i++) {
        let type = i == 0 ? 'main' : 'mobile';
        const lowRes = type == 'main' ? customFeatureImage.querySelector(`.homepage-hero__slide[data-index="${index}"] #feature-video-desktop-lq`) : customFeatureImage.querySelector(`.homepage-hero__slide[data-index="${index}"] #feature-video-mobile-lq`);

        if(lowRes && data){
        const container = lowRes.closest('.homepage-hero__image-container');
        
        const highRes = returnVideoElement(data, type, 'regular');
        
        container.appendChild(highRes);
            highRes.addEventListener('loadeddata', () => {
            highRes.currentTime = lowRes.currentTime;
            highRes.play();
        
            requestAnimationFrame(() => {
                highRes.style.opacity = '1';
            });
        
            setTimeout(() => {
                lowRes.pause();
                lowRes.remove();
            }, 600);
            });
        
        highRes.load();
        }
    }
}


  function createLQVideoElement(parent, customFeatureImage, index) {
    if(window.Branch.homepageHero.data[`${parent.getAttribute('id')}`][index]){
        let dataFirstSlide = window.Branch.homepageHero.data[`${parent.getAttribute('id')}`][index];
        if(dataFirstSlide.video_src || dataFirstSlide.video_src_lq){

        /* On mobile (<600px) with no mobile-specific video, defer video loading
           until first user interaction. The static poster image in the HTML serves
           as the LCP hero. Once the user scrolls or touches, the video loads and
           fades in over the poster. This keeps the video completely outside
           Lighthouse's trace (which never generates user interactions). */
        if(window.innerWidth < 600 && !dataFirstSlide.mobile_video_src && !dataFirstSlide.mobile_video_src_lq){
            var videoLoaded = false;
            const deferredLoad = function(){
                if(videoLoaded) return;
                videoLoaded = true;
                let video_quality = dataFirstSlide.video_src_lq ? 'lq' : 'regular';
                let videoElement = returnVideoElement(dataFirstSlide, 'main', video_quality);
                const containers = customFeatureImage.querySelectorAll(`.swiper-slide[data-index="${index}"] .homepage-hero__image-container`);
                containers.forEach((container) => {
                    container.appendChild(videoElement);
                    container.setAttribute('data-main-video-initialized', true);
                    videoElement.addEventListener('loadeddata', () => {
                        videoElement.play();
                        requestAnimationFrame(() => {
                            videoElement.style.opacity = '1';
                        });
                    });
                });
                ['scroll','touchstart','click','mousemove'].forEach(function(evt){
                    document.removeEventListener(evt, deferredLoad, {capture:true});
                });
            };
            ['scroll','touchstart','click','mousemove'].forEach(function(evt){
                document.addEventListener(evt, deferredLoad, {once:true, capture:true});
            });
            return true;
        }

        let type = window.innerWidth < 600 && dataFirstSlide.mobile_video_src ? 'mobile' : 'main';
        let video_quality = type == "mobile" ? dataFirstSlide.mobile_video_src_lq ? 'lq' : 'regular' : dataFirstSlide.video_src_lq ? 'lq' : 'regular';
        let videoElement = returnVideoElement(dataFirstSlide, type, video_quality);
        const containers = customFeatureImage.querySelectorAll(`.swiper-slide[data-index="${index}"] .homepage-hero__image-container`);
        containers.forEach((container) => {
            container.appendChild(videoElement);
            container.setAttribute(`data-${type}-video-initialized`, true);
            videoElement.addEventListener('loadeddata', () => {
                videoElement.play();
                requestAnimationFrame(() => {
                    videoElement.style.opacity = '1';
                });
            });
        })
    }
    }
    return true;
  }

  function setAutoplayTimeout(customFeatureImage, parent, delay){
    customFeatureImageAutoplayTimeouts[`${parent.getAttribute('id')}`] = setTimeout(() => {
        let standIn = customFeatureImage.querySelector('.homepage-hero__pagination-stand-in');
        
        initializeCustomFeatureImageSwiper(parent, 1, standIn);
    }, delay);
  }
 
  window.Branch.homepageHero.initLQVideoImmediately = function(){
    let customFeatureImages = document.querySelectorAll('.homepage-hero[data-first-slide-contains-video="true"]:not([data-lq-video-initialized="false"])');
    customFeatureImages.forEach((customFeatureImage) => {
        customFeatureImage.setAttribute('data-lq-video-initialized', 'true');
        let parent = customFeatureImage.closest('.shopify-section');
        if(!window.Branch.homepageHero.data[`${parent.getAttribute('id')}`]) {
            window.Branch.homepageHero.data[`${parent.getAttribute('id')}`] = [];
            customFeatureImage.querySelectorAll('.homepage-hero__slide').forEach((slide) => {
                window.Branch.homepageHero.data[`${parent.getAttribute('id')}`].push(slide.querySelector('.custom-feature-img-video-settings') ? JSON.parse(slide.querySelector('.custom-feature-img-video-settings').innerText) : {})
            });
            createLQVideoElement(parent, customFeatureImage, 0);

            if(customFeatureImage.getAttribute('data-autoplay-enable') == 'true'){
                let delay = parseInt(customFeatureImage.getAttribute('data-autoplay-delay'));
                let video = customFeatureImage.querySelector('video')
                if(video){                    
                    waitForVideoMetadata(video).then(duration => {
                        delay = duration * 1000;
                        setAutoplayTimeout(customFeatureImage, parent, delay)
                    });
                } else {
                    setAutoplayTimeout(customFeatureImage, parent, delay)
                }     
            }
        }
    });

    let customFeatureImagesWithoutVideo = document.querySelectorAll('.homepage-hero[data-first-slide-contains-video="false"]:not([data-lq-video-initialized="false"])');
        customFeatureImagesWithoutVideo.forEach((customFeatureImage) => {
                let parent = customFeatureImage.closest('.shopify-section');
                if(!window.Branch.homepageHero.data[`${parent.getAttribute('id')}`]) {
                    window.Branch.homepageHero.data[`${parent.getAttribute('id')}`] = [];
                    customFeatureImage.querySelectorAll('.homepage-hero__slide').forEach((slide) => {
                        window.Branch.homepageHero.data[`${parent.getAttribute('id')}`].push(slide.querySelector('.custom-feature-img-video-settings') ? JSON.parse(slide.querySelector('.custom-feature-img-video-settings').innerText) : {})
                    });
                }
                // Fallback: data-first-slide-contains-video is sourced from
                // section.blocks[0], but campaign-styling can reorder blocks so
                // the rendered slide 0 differs from blocks[0]. Inspect the
                // populated data array — if slide 0 actually has a video, create
                // it now so it autoplays on load instead of only after the
                // autoplay-timer kicks in and the user cycles back.
                const firstSlideData = window.Branch.homepageHero.data[`${parent.getAttribute('id')}`][0] || {};
                if(firstSlideData.video_src || firstSlideData.video_src_lq){
                    createLQVideoElement(parent, customFeatureImage, 0);
                }
                let delay = parseInt(customFeatureImage.getAttribute('data-autoplay-delay'));
                setAutoplayTimeout(customFeatureImage, parent, delay)
            });
  }

    window.Branch.homepageHero.updateImageSrcSetOnInit = function(){
        window.Branch.nav.handleUpdateSrcSet(null, '.homepage-hero__image-mobile', '.homepage-hero__slide:not([data-index="0"])', 900);     
        window.Branch.nav.handleUpdateSrcSet(null, '.homepage-hero__image', '.homepage-hero__slide:not([data-index="0"])', 2100);     
        window.Branch.nav.handleUpdateSrcSet(null, '.homepage-hero__image-tablet', '.homepage-hero__slide:not([data-index="0"])', 1280);     
  }


  window.Branch.homepageHero.initLQVideoImmediately();

  function loadOtherVideoOnResize(){
    const type = window.innerWidth < 600 ? 'mobile' : 'main';
    let containers = document.querySelectorAll(`.homepage-hero .homepage-hero__image-container:not([data-${type}-video-initialized="true"])`);
    containers.forEach((container) => {
        const slide = container.closest('.homepage-hero__slide');
        // Only video slides get a video — never image slides (or their loop clones). Previously
        // this appended slide 0's video (data[id][0]) to *every* uninitialized container, which is
        // how an image slide ended up playing another slide's video over its background image.
        if (!slide || slide.getAttribute('data-type') !== 'video') return;
        // Source the video from this slide's own settings, not slide 0's.
        const settingsEl = slide.querySelector('.custom-feature-img-video-settings');
        let data;
        try { data = settingsEl ? JSON.parse(settingsEl.innerText) : null; } catch (e) { data = null; }
        if (!data || !data.mobile_video_src) return;
        container.setAttribute(`data-${type}-video-initialized`, true);
        let videoElement = returnVideoElement(data, type, 'regular');
        container.appendChild(videoElement);
        videoElement.addEventListener('loadeddata', () => {
            videoElement.play();
            requestAnimationFrame(() => {
                videoElement.style.opacity = '1';
            });
        });
    })
  }

    function updateOtherSlidesVideosOnInitSwipe(parent, slideToIndex){
        // Gate on data-type="video": image slides (and image-slide loop clones, which share the
        // same data-index) must never have a video injected over their background image.
        let customFeatureImageContainers = parent.querySelectorAll(`.homepage-hero .homepage-hero__slide[data-index="${slideToIndex}"][data-type="video"] .homepage-hero__image-container:not([data-${window.innerWidth < 600 ? 'mobile' : 'main'}-video-initialized="true"])`);
        
        customFeatureImageContainers.forEach((customFeatureImageContainer) => {
            let parent = customFeatureImageContainer.closest('.shopify-section');
            let index = parseInt(customFeatureImageContainer.closest('.homepage-hero__slide').getAttribute('data-index'));
            let customFeatureImage = customFeatureImageContainer.closest('.homepage-hero');
            if(window.Branch.homepageHero.data[`${parent.getAttribute('id')}`]){
                createLQVideoElement(parent, customFeatureImage, index);
                loadHQVideo(customFeatureImage, index);
            }
        })
    }

    function animateSlideLines(slide, allSlides, slideIndex) {
        allSlides.forEach((slide, index) => {
            const lines = slide.querySelectorAll('.homepage-hero__title, .homepage-hero__subtitle, .homepage-hero__cta, .homepage-hero__secondary-subtitle');
            lines.forEach((line, index) => {
                line.classList.remove('animate-up');
                line.removeAttribute('data-animate-slide-in');
                line.removeAttribute('data-cascade-order');
            });
            slide.dataset.animated = "false"; 
        })

        const lines = slide.querySelectorAll('.homepage-hero__title, .homepage-hero__subtitle, .homepage-hero__cta, .homepage-hero__secondary-subtitle');
        lines.forEach((line, index) => {
            setTimeout(() => {
            line.classList.add('animate-up');
            }, index * 100);
        });
    }

  function initializeCustomFeatureImageSwiper(parent, slideToIndex, standIn) {
     window.Branch.homepageHero.updateImageSrcSetOnInit();

    if(customFeatureImageSwipes[`${parent.getAttribute('id')}`]){
        customFeatureImageSwipes[`${parent.getAttribute('id')}`].remove();
    }

    // Tear down any previous Swiper for this section before re-creating. Without this, a
    // personalization innerHTML swap (or a second init) leaves the old instance bound to
    // now-detached nodes — leaking its resize/transition listeners and stale loop clones.
    const existingSwiper = window.Branch.homepageHero.swipers[`${parent.getAttribute('id')}`];
    if (existingSwiper && typeof existingSwiper.destroy === 'function') {
        existingSwiper.destroy(true, true);
    }

    if(customFeatureImageAutoplayTimeouts[`${parent.getAttribute('id')}`]){
        clearTimeout(customFeatureImageAutoplayTimeouts[`${parent.getAttribute('id')}`])
    }

    if(standIn){standIn.setAttribute('data-clicked', true)};
    if(parent.querySelector('.swiper-pagination')){
        parent.querySelector('.swiper-pagination').setAttribute('data-clicked', true);      
    }
    
    let sliderSelector = `#${parent.getAttribute('id')} .homepage-hero.swiper`;
    let autoplayEnabled = parent.querySelector('.homepage-hero').getAttribute('data-autoplay-enable') === 'true';

    let autoplayDelay = autoplayEnabled ? parseInt(parent.querySelector('.homepage-hero').getAttribute('data-autoplay-delay')) : 0;

    // Count actual (non-clone) slides rendered by Liquid. With a single slide
    // Swiper's loop mode still clones it into prev/next duplicates, which makes
    // the hero feel like it has 3 slides (user can swipe through clones of the
    // same video). Gate loop + swipe on slideCount > 1 so single-slide heroes
    // behave as a static block.
    const heroEl = parent.querySelector('.homepage-hero.swiper');
    const slideCount = heroEl
        ? heroEl.querySelectorAll(':scope > .swiper-wrapper > .homepage-hero__slide:not(.swiper-slide-duplicate)').length
        : 0;
    const hasMultipleSlides = slideCount > 1;

    window.Branch.homepageHero.swipers[`${parent.getAttribute('id')}`] = new Swiper(sliderSelector, {
        pagination: {
            el: `#${parent.getAttribute('id')} .homepage-hero.swiper .swiper-pagination`,
            dynamicBullets: true,
            clickable: true,
        },
        loop: hasMultipleSlides,
        allowTouchMove: hasMultipleSlides,
        simulateTouch: hasMultipleSlides,
        autoplay: autoplayEnabled && hasMultipleSlides ? {delay: autoplayDelay, disableOnInteraction: false} : false,
        
        on: {
          init: function () {
            this.slideTo(slideToIndex + 1, 500, false);
            updateOtherSlidesVideosOnInitSwipe(parent, slideToIndex);
            animateSlideLines(this.slides[this.activeIndex], this.slides, this.activeIndex);
          },
        slideChangeTransitionEnd: function () {
            const activeSlide = this.slides[this.activeIndex];
            if (activeSlide.dataset.animated != "true") {
                animateSlideLines(activeSlide, this.slides, this.activeIndex);
            }
        },
          slideChangeTransitionStart: function () {
            const currentSlide = this.slides[this.activeIndex];
            updateOtherSlidesVideosOnInitSwipe(parent, parseInt(currentSlide.getAttribute('data-index')));
            if(parent.querySelector('.homepage-hero').getAttribute('data-autoplay-enable') === 'true') {
                let defaultImageDelay = parseInt(parent.querySelector('.homepage-hero').getAttribute('data-autoplay-delay'));
                const slideType = currentSlide.getAttribute('data-type');

                this.autoplay.stop();
                if (slideType === 'video') {
                    waitForVideoAndSetDelay(currentSlide, this, defaultImageDelay);
                } else {
                    setAutoplayDelay(this, defaultImageDelay);
                }
            }
          }
        }
      })
  }

  function waitForVideoMetadata(video) {
    return new Promise(resolve => {
        if (video.readyState >= 1) {
            resolve(video.duration);
        } else {
            video.addEventListener('loadedmetadata', () => {
                resolve(video.duration);
            }, { once: true });
            video.load();
        }
    });
}


  function waitForVideoAndSetDelay(slide, swiperInstance, defaultImageDelay) {
    const pollInterval = 50;
    const maxAttempts = 100;
    let attempts = 0;
  
    const checkVideo = () => {
      const video = slide.querySelector('video');
      if (video) {
        waitForVideoMetadata(video).then(duration => {
            let delay = duration * 1000;
            setAutoplayDelay(swiperInstance, delay, video);
        });
    

      } else {
        attempts++;
        if (attempts < maxAttempts) {
          setTimeout(checkVideo, pollInterval);
        } else {
          setAutoplayDelay(swiperInstance, defaultImageDelay, video);
        }
      }
    };
  
    checkVideo();
  }

  function setAutoplayDelay(swiper, delay, video) {
    swiper.params.autoplay.delay = delay;
    if(video) {
        video.pause();
        video.currentTime = 0;
    }
    swiper.autoplay.start();
    if(video) {
        video.play();
    }
  }

    let customFeatureImageResizeTimeout;

    let customFeatureImageSwipes = {};

    window.Branch.homepageHero.homepageHeroInitOnLoad = function(){
        document.querySelectorAll('.homepage-hero:not([data-loaded="true"])').forEach((customFeatureImage, index) => {
        customFeatureImage.setAttribute('data-loaded', true);
            let standIn = customFeatureImage.querySelector('.homepage-hero__pagination-stand-in');
            let parent = customFeatureImage.closest('.shopify-section');

            if(standIn) {
                customFeatureImageSwipes[`${parent.getAttribute('id')}`] =
                    window.Branch.functions.setupSwipeListener(parent, () => initializeCustomFeatureImageSwiper(parent, 1, standIn), {
                        threshold: 40,
                        once: true 
                      })            
            } else {
                customFeatureImageSwipes[`${parent.getAttribute('id')}`] = undefined;
            }
        });

        let customFeatureImages = document.querySelectorAll('.homepage-hero:not([data-initialized="true"])');
        customFeatureImages.forEach((customFeatureImage) => {
            customFeatureImage.setAttribute('data-initialized', true);
            loadHQVideo(customFeatureImage, 0);

            if(customFeatureImage.closest('.homepage-hero__form-slider-container')){
                 window.addEventListener('click', function(e){
                    if (e.target.closest(`#${customFeatureImage.closest('.shopify-section').getAttribute('id')} .homepage-hero__form-overlay-cta`)){
                        e.preventDefault();
                        const sliderContainer = e.target.closest('.homepage-hero__form-slider-container');
                        if (!sliderContainer) return;
                        let cta = e.target.closest(`#${customFeatureImage.closest('.shopify-section').getAttribute('id')} .homepage-hero__form-overlay-cta`);
                        if(cta.getAttribute('data-click-through') == 'empty form') {
                            cta.removeAttribute('data-click-through');
                            sliderContainer.querySelector('.homepage-hero__form-overlay-input').style.display = 'block';
                            
                            let inputs = sliderContainer.querySelectorAll('.homepage-hero__form-container input[name="contact[name]"], .homepage-hero__form-container input[name="contact[lastname]"], .homepage-hero__form-container input[name="contact[company]"], .homepage-hero__form-container input[name="contact[email]"]');
                            
                            // console.log('inputs', inputs);
                            
                            inputs.forEach((input) => {
                                input.value = '';
                            });
                            
                            sliderContainer.querySelectorAll('.homepage-hero__image-container').forEach((imageContainer) => {
                                imageContainer.style.removeProperty('height');
                            })

                            cta.innerHTML = cta.getAttribute('data-cta-text');
                            sliderContainer.setAttribute('data-step', 1)
                            return
                        }

                        sliderContainer.setAttribute('data-step', 2);
                        const emailInput = sliderContainer.querySelector('.homepage-hero__form-overlay-input');
                        const contactEmailInput = sliderContainer.querySelector('input[name="contact[email]"]');
                        const formWrap = sliderContainer.querySelector('.form-wrap');
                        const overlay = sliderContainer.querySelector('.homepage-hero__form-overlay');

                        if (emailInput && contactEmailInput) {
                            contactEmailInput.value = emailInput.value;
                        }

                        if (formWrap && overlay) {
                            overlay.style.height = overlay.offsetHeight;
                            overlay.setAttribute('data-visible', 'false');                            

                            setTimeout(() => {
                                const formWrapHeight = window.innerWidth < 1024 ? formWrap.querySelector('.form-wrap-inner').offsetHeight + 120 : formWrap.querySelector('.form-wrap-inner').offsetHeight + 160;
                                overlay.style.height = `${formWrapHeight}px`;
                                if(window.innerWidth > 599){
                                    sliderContainer.querySelectorAll('.homepage-hero__image-container').forEach((imageContainer) => {
                                        imageContainer.style.height = `${formWrapHeight}px`;
                                    })
                                }
                                
                                setTimeout(() => {
                                    formWrap.setAttribute('data-visible', 'true');
                                    const lines = formWrap.querySelectorAll('#subscription-popup-title, #subscription-popup-title + p, .chat-with-sales-content__input-wrapper [data-content="contact[name]"], .chat-with-sales-content__input-wrapper [data-content="contact[lastname]"],  .chat-with-sales-content__input-wrapper [data-content="contact[email]"], .chat-with-sales-content__input-wrapper [data-content="contact[company]"], .chat-with-sales-content__input-wrapper [data-content="contact[phone]"], .office-size-radio-group, .btn, .chat-with-sales-content__cta-sub-text');
                                        lines.forEach((line, index) => {
                                            setTimeout(() => {
                                            line.classList.add('animate-up');
                                            }, index * 100);
                                        });
                                }, 500);
                            }, 1);
                        }
                    } 
                });
            }
        });

        window.addEventListener('resize', () => {
            clearTimeout(customFeatureImageResizeTimeout);
            customFeatureImageResizeTimeout = setTimeout(() => {
                loadOtherVideoOnResize();

                document.querySelectorAll('.homepage-hero__form-slider-container[data-step="2"]').forEach((sliderContainer) => {
                    let formWrapHeight = sliderContainer.querySelector('.form-wrap').offsetHeight;
                        sliderContainer.querySelectorAll('.homepage-hero__image-container').forEach((imageContainer) => {
                            if(window.innerWidth > 599){
                                imageContainer.style.height = `${formWrapHeight}px`;
                            } else {
                                imageContainer.style.removeProperty('height')
                            }  
                        })
                })
            }, 200); 
        });

        window.addEventListener('click', function(e){
            if (e.target.closest('.homepage-hero__pagination-stand-in')){
                let standIn = e.target.closest('.homepage-hero__pagination-stand-in')
                let parent = e.target.closest('.shopify-section');

                let slideToIndex = 1;
                if (e.target.closest('.homepage-hero__pagination-stand-in-dot')) {
                    slideToIndex = parseInt(e.target.closest('.homepage-hero__pagination-stand-in-dot').getAttribute('data-index'));
                }
                initializeCustomFeatureImageSwiper(parent, slideToIndex, standIn);
          } 
        });

        if(window.Branch && window.Branch.bfcm2025 && window.Branch.bfcm2025.adjustImageHeight && document.querySelector('.toggle-header__utility-bar[data-current="dtc"]')){
        let sectionId = document.querySelector('.homepage-hero[data-bfcm-2025-styling-enabled="true"]').closest('.homepage-hero-section').getAttribute('id');
            // Add delay to ensure fonts and content are fully loaded before calculating height
            setTimeout(() => {
                window.Branch.bfcm2025.adjustImageHeight(sectionId, true);
            }, 250);
            window.addEventListener('resize', function(){
                window.Branch.bfcm2025.adjustImageHeight(sectionId, true)
            });
            }
        }

    if (document.readyState === "complete") {
        window.Branch.homepageHero.homepageHeroInitOnLoad();
    } else {
        window.addEventListener("DOMContentLoaded", window.Branch.homepageHero.homepageHeroInitOnLoad);
    }
  })();
